export default class PrimaryMenu {
  /**
  ** 実行
  ** @constructor
  **/    
  constructor(){
    this.getParam()
    this.init()
  }

  /**
  ** 各種要素を取得している
  ** @getParam
  ** 
  **/  
  getParam () {
    this.backBtn = document.querySelectorAll(`[data-module='menu-back']`)
    this.ArrayBackBtn = [].slice.call(this.backBtn)

    this.startBtn = document.querySelectorAll(`[data-module='menu-first-slide'] > li`)
    this.ArrayStartBtn = [].slice.call(this.startBtn)

    this.categoryFirstBtn = document.querySelectorAll(`[data-module='menu-category-slide'] > li.is-nest`)
    this.ArrayCategoryFirstBtn = [].slice.call(this.categoryFirstBtn)        

    this.categorySecondBtn = document.querySelectorAll(`[data-module='menu-category-slide-child'] > li.is-nest`)
    this.ArrayCategorySecondBtn = [].slice.call(this.categorySecondBtn)


    this.categoryBackBtn = document.querySelectorAll(`[data-module='menu-child-back']`)
    this.ArrayCategoryBackBtn = [].slice.call(this.categoryBackBtn)

    this.categoryChildBackBtn = document.querySelectorAll(`[data-module='menu-grandchild-back']`)
    this.ArrayCategoryChildBackBtn = [].slice.call(this.categoryChildBackBtn)             

    this.ToggleClass = 'is-slide'
    this.ToggleCategoryClass = 'is-categoryslide'
  }

  /**
  ** オブジェクトを初期化
  ** @init
  **/    
  init () {
    this.backSlideEvent()
    this.startSlideEvent()

    this.categoryFirstEvent()
    this.categorySecondEvent()

    this.categorySecondBackEvent()
    this.categoryBackEvent()
  }


  /**
  ** 戻るボタンを押下しときの挙動
  ** @backSlideEvent
  **/
  backSlideEvent () {
    for(let i = 0; i < this.ArrayBackBtn.length; i++) {
      this.ArrayBackBtn[i].addEventListener('click',(e)=> {
        this.ArrayBackBtn[i].parentNode.classList.remove(this.ToggleClass)
        e.stopPropagation()
      }, false)
    }
  }

  /**
  ** 最初にカテゴリを押下した時
  ** @startSlideEvent
  **/

  startSlideEvent () {
    for(let i = 0; i < this.ArrayStartBtn.length; i++) {
      this.ArrayStartBtn[i].addEventListener('click',(e)=> {
        this.ArrayStartBtn[i].children[1].classList.add(this.ToggleClass)
        e.stopPropagation()
      }, false)
    }
  }

  /**
  ** 第一カテゴリを押下した時
  ** @categoryFirstEvent
  **/

  categoryFirstEvent () {
    for(let i = 0; i < this.ArrayCategoryFirstBtn.length; i++) {
      this.ArrayCategoryFirstBtn[i].addEventListener('click',(e)=> {
        const slideDom = this.ArrayCategoryFirstBtn[i].children[0]
        slideDom.classList.toggle(this.ToggleCategoryClass)
        e.stopPropagation()        
      }, false)
    }
  }

  /**
  ** 第二カテゴリをもどるボタン押下した時
  ** @categorySecondEvent
  **/

 categoryBackEvent () {
  for(let i = 0; i < this.ArrayCategoryBackBtn.length; i++) {
    this.ArrayCategoryBackBtn[i].addEventListener('click',(e)=> {
      this.ArrayCategoryBackBtn[i].parentNode.classList.remove(this.ToggleCategoryClass)
      e.stopPropagation()
     }, false)
   }
 }  

  /**
  ** 第二カテゴリを押下した時
  ** @categorySecondEvent
  **/

 categorySecondEvent () {
   for(let i = 0; i < this.ArrayCategorySecondBtn.length; i++) {
     this.ArrayCategorySecondBtn[i].addEventListener('click',(e)=> {
       const slideDom = this.ArrayCategorySecondBtn[i].children[0]
       slideDom.classList.toggle(this.ToggleCategoryClass)
       e.stopPropagation()
      }, false)
    }
  }

  /**
  ** 第二カテゴリをもどるボタン押下した時
  ** @categorySecondEvent
  **/

 categorySecondBackEvent () {
  for(let i = 0; i < this.ArrayCategoryChildBackBtn.length; i++) {
    this.ArrayCategoryChildBackBtn[i].addEventListener('click',(e)=> {
      this.ArrayCategoryChildBackBtn[i].parentNode.classList.remove(this.ToggleCategoryClass)
      e.stopPropagation()
     }, false)
   }
 }
}